import React from 'react';
import ReactDOM from 'react-dom/client';
import{
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom'
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import {Provider} from 'react-redux';
import store from './store';

import './assets/styles/bootstrap.custom.css';
import './assets/styles/index.css';
import './assets/styles/design-tokens.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import OpeningScreen from './screens/OpeningScreen';
import Home from './chatbot/Home';
import ChatWindow from './chatbot/ChatWindow';
import CartScreen from './screens/CartScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterSceen';
import ShippingScreen from './screens/ShippingScreen';
import PrivateRoute from './component/PrivateRoute';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import ProfileScreen from './screens/ProfileScreen';
import AdminRoute from './component/AdminRoute';
import OrderListScreen from './screens/admin/OrderListScreen';
import ProductListScreen from './screens/admin/ProductListScreen';
import ProductEditScreen from './screens/admin/ProductEditScreen';
import UserListScreen from './screens/admin/UserListScreen';
import UserEditScreen from './screens/admin/UserEditScreen';
import {HelmetProvider} from 'react-helmet-async';
import PriceQuote from './front-components/PriceQuote';
import InteractivePlanner from './front-components/InteractivePlanner';
import WeddingPlanScreen from './screens/WeddingPlanScreen';
import AboutScreen from './screens/AboutScreen';
import { Navigate } from 'react-router-dom';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index={true} path="/" element={<Navigate to="/interactive-planner" replace />} />
      {/* <Route index={true} path="/" element={<Home/>} />  */}
      <Route path="/home" element={<HomeScreen/>} />
      <Route path="/about" element={<AboutScreen />} />
      <Route path="/price-quote" element={<PriceQuote />} />
      <Route path="/interactive-planner" element={<InteractivePlanner />} />
      <Route path="/my-wedding-plan" element={<WeddingPlanScreen />} />
      <Route path="/home/search/:keyword" element={<HomeScreen/>} />
      <Route path="/home/page/:pageNumber" element={<HomeScreen/>} />
      <Route path="/home/search/:keyword/page/:pageNumber" element={<HomeScreen/>} />
      <Route path="/chat" element={<ChatWindow/>} />
      <Route path='/product/:id' element={<ProductScreen />} />
      <Route path='/cart' element={<CartScreen />} />
      <Route path='/login' element={<LoginScreen />} />
      <Route path='/register' element={<RegisterScreen />} />
      <Route path='' element={<PrivateRoute/>}>
        <Route path='/shipping' element={<ShippingScreen />} />
        <Route path='/payment' element={<PaymentScreen />} />
        <Route path='/placeorder' element={<PlaceOrderScreen />} />
        <Route path='/order/:id' element={<OrderScreen />} />
        <Route path='/profile' element={<ProfileScreen />} />
      </Route>
      <Route path='' element={<AdminRoute/>}>
        <Route path='/admin/orderlist' element={<OrderListScreen />} />
        <Route path='/admin/productlist' element={<ProductListScreen />} />
        <Route path='/admin/productlist/:pageNumber' element={<ProductListScreen />} />
        <Route path='/admin/product/:id/edit' element={<ProductEditScreen />} />
        <Route path='/admin/userlist' element={<UserListScreen />} />
        <Route path='/admin/user/:id/edit' element={<UserEditScreen />} />
      </Route>

    </Route>
  )
)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <Provider store={store}>
      <PayPalScriptProvider deferLoading={true}>
        <RouterProvider router={router}/>
      </PayPalScriptProvider>
    </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();